<app-icon class="background" name="selected-item-composition-background" />
<app-icon class="overlay is-overlay" name="selected-item-composition-overlay" />
